import React from 'react';
import './index.css';

const LeadUploadCard = ({ children }) => {
  return (
    <div className="upload-card-wrapper">
      {children}
    </div>
  )
}

const Header = ({ children }) => (
  <div className="upload-card-step-number">
    {children}
  </div>
)

LeadUploadCard.Header = Header;

const Title = ({ children }) => (
  <div className="upload-card-step-title">
    {children}
  </div>
)

LeadUploadCard.Title = Title;


const Body = ({ children }) => (
  <div className="upload-card-content">
    {children}
  </div>
)
LeadUploadCard.Body = Body;

const Actions = ({ children }) => (
  <div className="upload-card-button">
    {children}
  </div>
)
LeadUploadCard.Actions = Actions;

export default LeadUploadCard;